import { render, staticRenderFns } from "./IconSvgGlobeCircle.vue?vue&type=template&id=5d63b2fb&scoped=true&"
import script from "./IconSvgGlobeCircle.vue?vue&type=script&lang=js&"
export * from "./IconSvgGlobeCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63b2fb",
  null
  
)

export default component.exports